"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOfficeUsageSubformFlatRate5EurResults = void 0;
const utils_1 = require("../utils");
const FALLBACK_YEAR = 0;
const CALCULATION_CONFIG = {
    [FALLBACK_YEAR]: {
        expensesPerDay: 500,
        maxDaysUsed: 120,
    },
    [2023]: {
        expensesPerDay: 600,
        maxDaysUsed: 210,
    },
};
const getLatestMatchedConfigYear = (declarationYear) => Math.max(...Object.keys(CALCULATION_CONFIG)
    .map((year) => Number(year))
    .filter((year) => year <= declarationYear));
const getCalculationConfig = (declarationYear) => {
    const configYear = getLatestMatchedConfigYear(declarationYear);
    return CALCULATION_CONFIG[configYear];
};
const calculateOfficeUsageSubformFlatRate5EurResults = ({ daysUsed }, declarationYear) => {
    (0, utils_1.validateAmounts)([daysUsed]);
    const { maxDaysUsed, expensesPerDay } = getCalculationConfig(declarationYear);
    const homeOfficeExpenses = Math.min(daysUsed, maxDaysUsed) * expensesPerDay;
    return {
        homeOfficeExpenses,
        profitReduction: homeOfficeExpenses,
    };
};
exports.calculateOfficeUsageSubformFlatRate5EurResults = calculateOfficeUsageSubformFlatRate5EurResults;
//# sourceMappingURL=flatRate5Eur.js.map